// extracted by mini-css-extract-plugin
export var active = "styles-module--active--db643";
export var footer = "styles-module--footer--abc70";
export var isScrollHidden = "styles-module--isScrollHidden--2c912";
export var menu = "styles-module--menu--ea126";
export var ps__railY = "styles-module--ps__rail-y--effce";
export var rotateIcon = "styles-module--rotateIcon--168dc";
export var sectionLink = "styles-module--sectionLink--918c5";
export var sectionLinks = "styles-module--sectionLinks--bfdc1";
export var sections = "styles-module--sections--bf897";
export var sidebarDefaultBullet = "styles-module--sidebarDefaultBullet--51731";
export var sidebarLeafBullet = "styles-module--sidebarLeafBullet--efa14";
export var specialIcon = "styles-module--specialIcon--cf500";